module.exports = __webpack_public_path__ + "static/img/aiimg.87bfae60.png";